import { ErrorBlock } from '@/components/common/ErrorBlock'
import { FloatingBox } from '@/components/common/Floating'

import styles from './CardModalFallback.module.scss'

export const CardModalFallback = () => (
  <div className={styles.container}>
    <FloatingBox content={<ErrorBlock />} styled variant='box' />
  </div>
)
